import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBranding, resolveLogoUrl } from "@/context/BrandingContext";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { LogOut, Users, Package, ClipboardList, FileBarChart, Palette, Rocket, Wallet } from "lucide-react";
import SolicitantesTab from "@/pages/admin/SolicitantesTab";
import ItensTab from "@/pages/admin/ItensTab";
import PedidosTab from "@/pages/admin/PedidosTab";
import RelatorioTab from "@/pages/admin/RelatorioTab";
import FinanceiroTab from "@/pages/admin/FinanceiroTab";
import PersonalizacaoTab from "@/pages/admin/PersonalizacaoTab";
import DeployTab from "@/pages/admin/DeployTab";

const tabs = [
  { v: "solicitantes", label: "Solicitantes", Icon: Users, C: SolicitantesTab },
  { v: "itens", label: "Itens", Icon: Package, C: ItensTab },
  { v: "pedidos", label: "Pedidos", Icon: ClipboardList, C: PedidosTab },
  { v: "financeiro", label: "Financeiro", Icon: Wallet, C: FinanceiroTab },
  { v: "relatorio", label: "Relatório", Icon: FileBarChart, C: RelatorioTab },
  { v: "personalizacao", label: "Personalização", Icon: Palette, C: PersonalizacaoTab },
  { v: "deploy", label: "Publicar site", Icon: Rocket, C: DeployTab },
];

export default function AdminDashboard() {
  const { user, logout } = useAuth();
  const { branding } = useBranding();
  const nav = useNavigate();
  const doLogout = () => { logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {resolveLogoUrl(branding.logo_url) ? (
              <img src={resolveLogoUrl(branding.logo_url)} alt="logo" className="h-9 w-9 rounded object-cover" />
            ) : (
              <div className="h-9 w-9 rounded bg-brand text-white flex items-center justify-center font-heading font-bold">A</div>
            )}
            <div>
              <div className="font-heading font-bold text-slate-900">Painel Administrativo</div>
              <div className="text-xs text-slate-500">{branding.company_name} · {user?.username}</div>
            </div>
          </div>
          <Button data-testid="admin-logout-btn" variant="outline" size="sm" onClick={doLogout} className="rounded-full">
            <LogOut className="h-4 w-4 mr-2" /> Sair
          </Button>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-8">
        <Tabs defaultValue="solicitantes" className="space-y-6">
          <TabsList className="bg-white border border-slate-200 p-1 flex flex-wrap h-auto">
            {tabs.map(({ v, label, Icon }) => (
              <TabsTrigger
                key={v} value={v} data-testid={`admin-tab-${v}`}
                className="data-[state=active]:bg-slate-900 data-[state=active]:text-white"
              >
                <Icon className="h-4 w-4 mr-2" /> {label}
              </TabsTrigger>
            ))}
          </TabsList>
          {tabs.map(({ v, C }) => (
            <TabsContent key={v} value={v}><C /></TabsContent>
          ))}
        </Tabs>
      </main>
    </div>
  );
}
